import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const CallToAction = () => {
  return (
    <>
      <Box
        sx={{
          background: (theme) => theme.palette.gradient.primary,
          color: "white",
          py: { xs: 8, md: 10 },
        }}
      >
        <Container maxWidth="md">
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="h1"
              gutterBottom
              sx={{
                fontWeight: 700,
                mb: 2,
              }}
            >
              Ready to Get Started?
            </Typography>
            <Typography
              variant="h6"
              sx={{
                mb: 4,
                opacity: 0.9,
              }}
            >
              Apply for your cash loan today and get the money you need within
              hours. Our simple application process makes it easy.
            </Typography>
            <Button
              component={RouterLink}
              to="/apply"
              variant="contained"
              size="large"
              endIcon={<ArrowForwardIcon />}
              sx={{
                background: "white",
                color: (theme) => theme.palette.primary.main,
                border: "2px solid white",
                "&:hover": {
                  background: (theme) => theme.palette.primary.main,
                  color: "white",
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 20px rgba(255, 255, 255, 0.1)",
                },
                px: 4,
                py: 1.5,
                fontSize: "1.1rem",
              }}
            >
              Apply Now
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Important Information Section */}
      <Box
        sx={{
          background: "white",
          py: { xs: 6, md: 6 },
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              mb: 1,
              textAlign: "center",
              color: "primary.main",
            }}
          >
            Important Information
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#4a5568",
              lineHeight: 1.8,
              mb: 1,
              textAlign: "center",
            }}
          >
            MRLOANS is committed to responsible lending practices. All loan
            applications are subject to credit and affordability assessments in
            accordance with the National Credit Act. Terms and conditions apply
            to all loan products.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#4a5568",
              lineHeight: 1.8,
              mb: 1,
              textAlign: "center",
            }}
          >
            Interest rates, fees, and repayment terms vary based on your credit
            profile and loan amount. We recommend borrowing only what you can
            comfortably afford to repay. Late or missed payments may result in
            additional fees and negatively impact your credit score.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#4a5568",
              lineHeight: 1.8,
              textAlign: "center",
            }}
          >
            By submitting an application, you consent to us conducting credit
            and fraud prevention checks. Your personal information will be
            handled in accordance with our Privacy Policy and the Protection of
            Personal Information Act (POPIA).
          </Typography>
        </Container>
      </Box>
    </>
  );
};

export default CallToAction;
